import { render, staticRenderFns } from "./ProductsManagement.vue?vue&type=template&id=984ebe28&scoped=true"
import script from "./ProductsManagement.vue?vue&type=script&lang=js"
export * from "./ProductsManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductsManagement.vue?vue&type=style&index=0&id=984ebe28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ebe28",
  null
  
)

export default component.exports